/** @jsx jsx */
/** @jsxFrag null */
import {AttrsSchema, Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {SvgIconEl} from 'common/components/svg-icon';

import css from './index.inline.styl';

interface TwoStepDiagramJsxProps {
  attrs: {'step-names': [string, string]};
}

export class TwoStepDiagram extends Component<EmptyObj, TwoStepDiagramJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<TwoStepDiagramJsxProps['attrs']> {
    return {
      'step-names': {type: `json`, tsType: `[string, string]`},
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      template: () => {
        const [step1, step2] = this.attr(`step-names`);

        return (
          <div sel='.root'>
            <div sel='.steps-context'>
              <div sel='.step'>{step1}</div>
              <SvgIconEl attrs={{icon: `arrow-right`}} />
              <div sel='.step'>{step2}</div>
            </div>
          </div>
        );
      },
    };
  }
}

export const TwoStepDiagramEl = defineAndMakeJsxFactory<TwoStepDiagramJsxProps>(`mp-two-step-diagram`, TwoStepDiagram);
export const TwoStepDiagramReact = panel2react<TwoStepDiagramJsxProps>(`mp-two-step-diagram`, TwoStepDiagram);
